// Customer package tiers (חבילות). Stored on `companies.package` as one
// of: "basic" | "pro" | "business" | "elite" | null. The label below is
// what every UI surfaces (super-admin card, modal, client sidebar).
export const PACKAGE_LABELS = {
  basic: "חבילת בסיס",
  pro: "חבילת פרו",
  business: "חבילת ביזנס",
  elite: "חבילת אליט",
};

export const PACKAGE_OPTIONS = [
  { value: "basic", label: PACKAGE_LABELS.basic },
  { value: "pro", label: PACKAGE_LABELS.pro },
  { value: "business", label: PACKAGE_LABELS.business },
  { value: "elite", label: PACKAGE_LABELS.elite },
];

export function packageLabel(pkg) {
  return PACKAGE_LABELS[pkg] || "ללא חבילה";
}
